import styled from 'styled-components';
import { fontTitle, fontAccent, fontBody } from 'Styles/fonts';
import breakpoint from 'Styles/breakpoints';
import ProductOptionsOriginal from '../ProductOptions/ProductOptions';
import Button from '../../../Button/Button';
import DiscountAppliedMessageOriginal from '../../../DiscountAppliedMessage/DiscountAppliedMessage';
import ProductShippingGuidance from '../ProductShippingGuidance/ProductShippingGuidance';
import { Text } from '../../../RichText/RichText.styled';
import LinkText from '../../../LinkText/LinkText';
import FreeShippingUpsellOriginal from '../../../FreeShipping/components/FreeShippingUpsell/FreeShippingUpsell';
import {
  DiscountAppliedMessage,
  Container as DiscountAppliedMessageContainer
} from '../../../DiscountAppliedMessage/DiscountAppliedMessage.styled';
import { applyTextWrap } from '../../../ContentSystem/utils/utils';
import ProductCalloutsOriginal from '../ProductCallouts/ProductCallouts';

const SMALL_GAP_SIZE = 8;
const MEDIUM_GAP_SIZE = 16;

export const ProductOptions = styled(ProductOptionsOriginal)`
  padding: 0;
  width: 100%;
`;

// Identify children whose spacing should remain tight inside the middle wrapper
export const OrderedContainer = styled.div.attrs({
  'data-middle-wrapper-child-spacing': 'none'
})`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 16px;
  width: 100%;

  ${({ $styleQueryMode }) => breakpoint('medium', { mode: $styleQueryMode })} {
    ${ProductOptions} {
      order: -1;
    }

    order: 0;
    align-items: start;
  }
`;

export const UpperWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  ${breakpoint('medium')} {
    gap: ${SMALL_GAP_SIZE}px;
  }
`;

export const MiddleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 16px;

  /* apply spacing to any child unless it opts out via data attribute */
  & > *:not([data-middle-wrapper-child-spacing='none']) {
    margin-bottom: ${MEDIUM_GAP_SIZE}px;
    order: 2;
  }

  ${breakpoint('medium')} {
    padding-top: unset;
  }
`;

export const LowerWrapper = styled.div`
  padding-bottom: 16px;

  ${({ $styleQueryMode }) => breakpoint('medium', { mode: $styleQueryMode })} {
    padding-bottom: 24px;
  }
`;

export const DetailLinks = styled.div`
  background-color: var(--muted-background);
  border-radius: 12px;
`;

export const Header = styled.h1`
  color: var(--foreground);
  ${fontAccent(24)};
  margin: 0 auto 16px;
  text-align: center;

  ${({ $styleQueryMode }) => breakpoint('medium', { mode: $styleQueryMode })} {
    ${fontAccent(32)};
    margin: 8px 0 12px 0;
    text-align: unset;
  }
  ${applyTextWrap()}
`;

export const Subtitle = styled.div`
  & h2 {
    ${fontBody(16)};
    ${applyTextWrap()}
  }
`;

// Swatches stay opt-out so their existing layout is untouched
export const SwatchesElement = styled.div.attrs({
  'data-middle-wrapper-child-spacing': 'none'
})`
  display: block;
  margin-bottom: 16px;

  ${breakpoint('medium')} {
    order: 1;
  }
`;

export const AutoApplyMessage = styled(DiscountAppliedMessageOriginal)`
  width: 100%;

  & > div {
    margin-top: 0;
  }

  ${DiscountAppliedMessage} {
    border-top: unset;
  }

  ${DiscountAppliedMessageContainer} {
    padding-top: 4px;
  }
`;

export const PricePlaceholder = styled.div`
  margin-top: 12px;
  height: 41px;
`;

export const RelativeContainer = styled.div`
  position: relative;
  width: 100%;
`;

export const SizeGuideLink = styled(LinkText)`
  position: absolute;
  right: 0;
  transform: translate(0px, -2px);
`;

export const RelatedProductsContainer = styled.div`
  padding: 0;
  width: 100%;
`;

export const ImageWrapper = styled.div`
  display: block;
  margin: 0 -16px;

  ${breakpoint('medium')} {
    display: none;
  }
`;

export const AddToBagContainer = styled.div`
  width: 100%;
`;

export const AddToBagButton = styled(Button)`
  margin: 0;
`;

export const DescriptionDetails = styled.div`
  display: flex;
  justify-content: space-between;
  padding-top: 16px;
`;

export const ShippingGuidance = styled(ProductShippingGuidance)`
  margin-top: 0;
`;

export const FullDetailsButton = styled(Button).attrs({
  variant: 'secondary',
  isGhost: true
})`
  padding: 24px 0 0;
  height: unset;
  text-transform: none;
  text-decoration: underline;
  ${fontTitle(16)}
`;

export const FreeShippingReturns = styled.div`
  text-align: left;

  ${Text} {
    ${fontBody(16)};
  }
`;

export const FreeShippingUpsell = styled(FreeShippingUpsellOriginal)`
  margin: 0;
  width: 100%;
`;

export const ConfigContainer = styled.div`
  margin-top: 16px;
`;

export const QBSContainer = styled.div``;

export const QBSButton = styled(Button)`
  flex: 1;
  min-width: unset;
`;

export const QBSButtonContainer = styled.div`
  display: flex;
  gap: 8px;
  width: 100%;
  margin-top: -8px;
`;

export const PriceQBSDiscountContainer = styled.div`
  display: flex;

  flex-direction: ${({ $percentOff }) => ($percentOff ? 'column' : 'row')};
  gap: 8px;
`;

export const ProductCalloutsContainer = styled.div`
  padding: 0 16px 18px;
`;

export const ProductCallouts = styled(ProductCalloutsOriginal)`
  padding-bottom: 16px;
`;